export function aiActionLabelKey(suggestion) {
    switch (suggestion?.actionKey) {
        case "create_milestone_and_link_tasks":
            return "ai.action.createMilestoneAndLinkTasks";
        case "create_deliverable":
            return "ai.action.createMilestone";
        case "create_task":
            return "ai.action.createTask";
        case "create_project":
            return "ai.action.createProject";
        case "create_goal":
            return "ai.action.createGoal";
        case "create_team":
            return "ai.action.createTeam";
        default:
            return `ai.action.create.${suggestion?.entityType || "item"}`;
    }
}

export function aiActionLabel(suggestion, translate) {
    const label = translate(aiActionLabelKey(suggestion));
    const count = Number(suggestion?.actionCount || 0);
    return suggestion?.actionKey === "create_milestone_and_link_tasks" && count > 0
        ? `${label} (${count})`
        : label;
}
